import firstClientUrlDE from 'assets/images/Andreas_Reichert.jpeg';
import firstClientUrlBE from 'assets/images/Hassan_Ayed.jpeg';
import secondClientUrlBE from 'assets/images/Kevin_Verbesselt.png';
import secondClientUrlDE from 'assets/images/Markus_Thomas_Boldt.png';
import { useTranslation } from 'react-i18next';
import { AvailableCountries, AvailableLanguages } from 'types/users.types';
import { guessIsUserDE } from 'utils/helpers';

const resolveTestimoniesPictures = (country: AvailableCountries) => {
  if (country === AvailableCountries.germany) {
    return {
      firstClientUrl: firstClientUrlDE,
      secondClientUrl: secondClientUrlDE,
    };
  }
  return {
    firstClientUrl: firstClientUrlBE,
    secondClientUrl: secondClientUrlBE,
  };
};

const useLocalizedTestimonials = (
  country?: AvailableCountries,
): Array<{
  image: string;
  name: string;
  profession: string;
  content: string;
}> => {
  const { t, i18n } = useTranslation();

  const inferCountryFromLocale = (): AvailableCountries => {
    const i18nLanguage = i18n.language as AvailableLanguages;
    const isGermanLocale = (language: AvailableLanguages) =>
      [AvailableLanguages.de].includes(language);

    if (isGermanLocale(i18nLanguage) || guessIsUserDE()) {
      return AvailableCountries.germany;
    }

    return AvailableCountries.belgium;
  };

  const countryValue: AvailableCountries = country ?? inferCountryFromLocale();

  const { firstClientUrl, secondClientUrl } =
    resolveTestimoniesPictures(countryValue);
  return [
    {
      image: firstClientUrl,
      name: t('signup.testimonies.experts.client1.name.' + countryValue),
      profession: t(
        'signup.testimonies.experts.client1.profession.' + countryValue,
      ),
      content: t('signup.testimonies.experts.client1.content.' + countryValue),
    },
    {
      image: secondClientUrl,
      name: t('signup.testimonies.experts.client2.name.' + countryValue),
      profession: t(
        'signup.testimonies.experts.client2.profession.' + countryValue,
      ),
      content: t('signup.testimonies.experts.client2.content.' + countryValue),
    },
  ];
};

export default useLocalizedTestimonials;
